import { render, staticRenderFns } from "./HistoryMktReportVersion2.vue?vue&type=template&id=2bba3e21&scoped=true"
import script from "./HistoryMktReportVersion2.vue?vue&type=script&lang=js"
export * from "./HistoryMktReportVersion2.vue?vue&type=script&lang=js"
import style0 from "./HistoryMktReportVersion2.vue?vue&type=style&index=0&id=2bba3e21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bba3e21",
  null
  
)

export default component.exports